<template>
  <div>
    <px-view-header title="Cotações de frete" :breadcrumbs="breadcrumbs"/>
    <div class="mt-5">
      <listagem-cotacao-frete-header :on-click-refresh="onClickRefresh"
                                     :is-comprador="true"
                                     @change="onChangeFilter"/>
      <lista-cotacao-frete :cotacoes="cotacoes"
                           :loading="loading"
                           :on-change-options="onChangeOptions"
                           :options-list="optionsList"
                           :footer-options="footerOptions"
                           @update="onClickRefresh"/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-cotacao-frete/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import CotacoesFreteService from './cotacao-frete-service';
import ListaCotacaoFrete from './ListaCotacaoFrete.vue';
import ListagemCotacaoFreteHeader from './ListagemCotacaoFreteHeader.vue';

export default {
  mixins: [paginationMixin],
  props: {
    isComprador: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      cotacoes: {
        content: [],
        total: 0,
      },
      loading: false,
      breadcrumbs: [
        { text: 'Gestão de frete' },
        { text: 'Cotações de fretes' },
      ],
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemCotacaoFrete', ['stringFilter', 'listOptions']),
    ...mapGetters('user', ['user']),
    ...mapGetters('entidade', ['idEntidade']),
  },
  methods: {
    ...mapActions('listagemCotacaoFrete', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.updateFilter(this.stringFilter);
      this.resetPage();
      this.getCotacoes();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getCotacoes();
    },
    onClickRefresh() {
      this.getCotacoes();
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getCotacoes() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return CotacoesFreteService.getCotacoes({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.cotacoes = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    ListaCotacaoFrete,
    ListagemCotacaoFreteHeader,
  },
};
</script>
